import React from 'react';
import BlogPostContainer from './pages/blog-post/BlogPost.container';

function App() {
  return (
    <div className="App">
      <BlogPostContainer />
    </div>
  );
}

export default App;
